import Http from '@/utils/http'
import { RequestType } from '@/typings/enum/Common'
import NLoginApi = global.NLoginApi

class BankcardVag extends Http {
  [x: string]: any
  public async getBankcardVag(data: NLoginApi.getBankcardVagRequestData) {
    return await super.request<NLoginApi.getBankcardVagResponse>({
      url: '/bankcardVag/info',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  public async getExportBankCardExcel(data: NLoginApi.getBankcardVagRequestData) {
    return await super.request<NLoginApi.getBankcardVagRequestData>({
      url: '/bankcardVag/exportBankCardExcel',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data,
      responseType: 'blob'
    })
  }
}

export default BankcardVag
